module.exports = __webpack_public_path__ + "img/colorblast_hero.6f945ddb.png";